// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"54":"1e553e84","194":"9fcbdf6f","361":"74fc3f1a","511":"ceffbb0b"}[chunkId] + ".chunk.js";
};